import { mercadoPagoGateway } from "./mercadoPagoGateway.js";
import { mockGateway } from "./mockGateway.js";

export function getPaymentProviderName() {
  const fromEnv = String(import.meta.env.VITE_PAYMENT_PROVIDER || "").trim().toLowerCase();
  if (fromEnv) return fromEnv;

  // Fallback seguro: se nao houver provider definido, usa mock para nao travar dev.
  return "mock";
}

export function getPaymentGateway() {
  const provider = getPaymentProviderName();

  if (provider === "mercadopago") {
    return mercadoPagoGateway;
  }

  return mockGateway;
}
